/**
 * UUIDv7 made on the client, for idempotent creates: a retried call sends the
 * same ID, and the server returns the row it already has. Time-ordered like
 * the database's `uuidv7()`.
 */
export function uuidv7(now: number = Date.now()): string {
	const bytes = new Uint8Array(16);
	// Web Crypto in browsers and Node. React Native may lack it; these IDs only
	// need to be unique, not secret, so Math.random is an acceptable fallback there.
	const webCrypto = (
		globalThis as unknown as { crypto?: { getRandomValues?(a: Uint8Array): Uint8Array } }
	).crypto;
	if (webCrypto?.getRandomValues) webCrypto.getRandomValues(bytes);
	else for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
	let ms = now;
	for (let i = 5; i >= 0; i--) {
		bytes[i] = ms % 256;
		ms = Math.floor(ms / 256);
	}
	bytes[6] = 0x70 | ((bytes[6] ?? 0) & 0x0f);
	bytes[8] = 0x80 | ((bytes[8] ?? 0) & 0x3f);
	const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
	return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
